export const NEXT_PUBLIC_KENALL_PUBLIC_KEY: string =
  process.env.NEXT_PUBLIC_KENALL_PUBLIC_KEY ?? '';
